module.exports = __webpack_public_path__ + "static/CallunaSemibold-15c8bbbe8f8072d0b79bd95c3266dd69.woff2";